module.exports = __webpack_public_path__ + "static/media/2025_Golf_Brochure.c4ef53c6.pdf";